import * as React from 'react';
import {FunctionComponent} from 'react';
import {VictoryPie} from 'victory';

interface OwnProps {
    parts: Array<{
        label: string;
        fraction: number;
    }>;
    colorScale?: string[];
}

export const PieChart: FunctionComponent<OwnProps> = ({colorScale, parts}) => {
    return (
        <VictoryPie
            colorScale={colorScale}
            data={parts.filter((part) => part.fraction > 0).map((part) => ({x: part.label, y: part.fraction}))}
        />
    );
};
